import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'service-area-weight-last-mile-costs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
